import React from "react";
import {
    Button,
    Grid,
    CircularProgress,
    Card,
    CardContent,
    Typography, Box
} from "@mui/material";
import {useForm, Controller} from "react-hook-form";
import {ContractSelect} from "./ContractSelect";
import {EditableCargoList} from "./EditableCargoList";
import {Cargo, Contract} from "../../queries";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";
import {Done} from "~/ui/icons";
import {DateField} from "~/apps/core/ui/DateField";


export type TerminalReleaseFormProps = {
    onSubmit?: (value: Values) => any | Promise<any>
    defaultValue?: Values
}


export type Values = {
    Contract: Contract
    Date: Date
    CargoList: Cargo[]
}


export const TerminalReleaseForm = (props: TerminalReleaseFormProps) => {
    const {onSubmit, defaultValue} = props;
    const {formState, handleSubmit: submitWrapper, control} = useForm<Values>({
        defaultValues: defaultValue || {
            Contract: null,
            Date: "",
            CargoList: [],
        },
        mode: "all"
    });

    const {isValid, isSubmitting} = formState;
    const disabled = isSubmitting;

    return (
        <form onSubmit={submitWrapper(onSubmit)}>
            <Grid container direction="column" spacing={2} wrap="nowrap">
                <Grid item>
                    <Card>
                        <CardContent>
                            <Grid container direction="column" spacing={1}>
                                <Grid item>
                                    <Controller
                                        name="Date"
                                        control={control}
                                        rules={{required: true}}
                                        render={({value, onChange}) => (
                                            <DateField
                                                label="Дата ком. разрешения"
                                                fullWidth={true}
                                                value={value}
                                                onChange={onChange}
                                                disabled={disabled}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item>
                                    <Controller
                                        name="Contract"
                                        control={control}
                                        rules={{required: true}}
                                        render={({value, onChange}) => (
                                            <ContractSelect
                                                label="Договор"
                                                fullWidth
                                                value={value}
                                                onChange={onChange}
                                                disabled={disabled}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item>
                    <Typography variant="screenText">
                        Список грузов
                    </Typography>
                </Grid>
                <Grid item>
                    <Controller
                        name="CargoList"
                        control={control}
                        rules={{
                            required: true,
                            validate: (value) => {
                                if (!value?.length) {
                                    return "Выберите груз";
                                }
                            }
                        }}
                        render={({value, onChange}) => (
                            <EditableCargoList
                                value={value}
                                onChange={onChange}
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>
            </Grid>
            <Box height="80px"/>
            <FloatingActions>
                <Button
                    type="submit"
                    color="primary"
                    fullWidth={true}
                    disabled={!isValid || isSubmitting}
                    startIcon={isSubmitting ? (<CircularProgress size={16}/>) : (<Done/>)}

                >
                    Создать
                </Button>
            </FloatingActions>
        </form>
    )
}